export const MOCK_TILE = {
  client_id: "test-client-id",
  redirect_uris: "https://example.com",
  name: "Test Tile",
  scopes: {},
  has_own_layout: false,
  views: ["tile"],
  owners: [],
  skip_authorization: true,
  created: "2024-01-01",
  updated: "2024-01-01",
  uuid: "00000000-0000-0000-0000-000000000000",
  publisher: "Narmi",
  description: "A test tile",
  image: "grid",
  is_public: true,
  display_in_feed: true,
} satisfies API.NarmiTile;
